import { gql } from '@apollo/client'

export const CORE_LAB_RESULT_FIELDS = gql`
  fragment CoreLabResultFields on LabResult {
    id
    date
    source
    createdAt
    healthMetrics {
      id
      kind
      value
      date
      unit
      label
    }
    measurements {
      id
      values {
        ... on BloodPressureMeasurement {
          systolic
          diastolic
        }
        ... on SingleValueMeasurement {
          value
        }
      }
      value
      occurredAt
      description
      title
      externalSource
      type
      units
      createdAt
      healthDataType
    }
  }
`
